var map = {
	"./articles/png/bag1.png": "9a6c",
	"./articles/png/bag2.png": "7499",
	"./articles/png/bag3.png": "5ba4",
	"./articles/png/hat1.png": "586e",
	"./articles/png/jacket1.png": "7ecb",
	"./articles/png/jacket2.png": "5a0f",
	"./articles/png/jeans1.png": "e526",
	"./articles/png/shoe1.png": "760d",
	"./articles/png/shoe2.png": "b90d",
	"./articles/png/shoe3.png": "0c99",
	"./articles/png/shoe4.png": "573a",
	"./articles/png/sweater1.png": "45a8",
	"./articles/png/tshirt1.png": "a2e0",
	"./elements/charm_5.png": "1e31",
	"./elements/charm_6.png": "77f8",
	"./elements/charm_7.png": "5021",
	"./elements/charm_8.png": "b9d9",
	"./elements/charm_9.png": "5f68",
	"./frame_1.png": "aa5d",
	"./frame_contenuti.png": "6030",
	"./frame_contenuti_nologo.png": "89c3",
	"./img_sneaker_new_2.png": "26ff",
	"./menu/1_icn_sneaker.png": "6732",
	"./menu/1_icn_sneaker_bak.png": "7e65",
	"./menu/1_icn_sneaker_selezionata.png": "894e",
	"./menu/1_icn_sneaker_selezionata_bak.png": "911c",
	"./menu/2_icn_leather_jacket.png": "9556",
	"./menu/2_icn_sneaker.png": "3912",
	"./menu/3_icn_sneaker.png": "afb0",
	"./menu/3_icn_tshirt.png": "18fc",
	"./menu/4_icn_bg.png": "9f97",
	"./menu/5_icn_bag.png": "5362",
	"./menu/icn_scarpa_bianca.png": "630b",
	"./menu/icn_scarpa_bianca_selezionata.png": "ac08",
	"./menu/icn_scarpa_edit_1.png": "9cc7",
	"./menu/icn_scarpa_edit_1_selezionata.png": "eda5",
	"./menu/icn_scarpa_edit_2.png": "291b",
	"./menu/icn_scarpa_edit_2_selezionata.png": "86b8",
	"./menu/icn_scarpa_edit_3.png": "847d",
	"./menu/icn_scarpa_edit_3_selezionata.png": "17cb",
	"./sneaker_big.png": "26fb",
	"./swatch-0.png": "7171",
	"./swatch-5.png": "ab3d",
	"./ui/color_wheel.png": "2801",
	"./ui/icn_gomma.png": "4036",
	"./ui/icn_undo_1.png": "1b50",
	"./ui/icn_undo_2.png": "7e7d",
	"./ui/logo_top.png": "b57f",
	"./ui/pop_up.png": "cd0f",
	"./ui/tools/bucket.png": "ecfb",
	"./ui/tools/customContent.png": "7dc8",
	"./ui/tools/dirt.png": "e230",
	"./ui/tools/emoticon.png": "85bb",
	"./ui/tools/eraser.png": "0d79",
	"./ui/tools/handwriting.png": "2776",
	"./ui/tools/highlighter.png": "2e5c",
	"./ui/tools/lightMarker.png": "bf9b",
	"./ui/tools/strongMarker.png": "e70b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";